import { useClientAppConfigWebHandler_getFeature } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import accessUtils from '../../../utils/accessUtils';

import { useMultiplexBuildingSessionId } from './useMultiplexBuildingSessionId';

export const useMultiplexListingFlow = () => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { isLoading, data = 'false' } = useClientAppConfigWebHandler_getFeature(
    {
      appName: 'zrm_web',
      featureName: 'canAccessMultiplexListingFlow',
    },
    {
      meta: {
        tags: ['multiplexListingFlowAccess'],
        context: {
          api: 'ClientAppConfigWebHandler',
          details: 'canAccessMultiplexListingFlow',
        },
      },
    },
  );

  const canAccessMultiplexListingFlow = accessUtils.canAccessMultiplexListingFlow({
    canAccessMultiplexListingFlowResponse: data,
  });

  const isInMultiplexListingFlow = isLoading
    ? null
    : canAccessMultiplexListingFlow && Boolean(multiplexBuildingSessionId);

  return {
    isLoading,
    isInMultiplexListingFlow,
  };
};
